import React, { useState } from "react";
import styled from "styled-components";

import ArrowUp from "../../../src/assets/images/arrow_up_orange.svg.svg";

export default function LojinhaMobile({ channels }) {
  const [paymentType, setPaymentType] = useState("annual");
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");

  const handleRadioChange = (channelId, paymentType) => {
    setSelectedValue(channelId);
    setPaymentType(paymentType);
  };

  return (
    <Section>
      <Title>Assinaturas individuais</Title>
      <SubTitleDiv>
        <BenefitsDiv>
          Você também pode contratar seus streamings favoritos pelo UOL Play,
          aproveitar vários conteúdos originais e ainda ter acesso a todos os
          benefícios do Clube UOL.
        </BenefitsDiv>
      </SubTitleDiv>
      {channels.map((channel, index) => (
        <AccordionContainer id={channel.id}>
          <Accordion isOpen={openIndex === index} key={"accordion" + index}>
            <div className="accordion-header">
              <img src={channel.tabImageUrl} alt={channel.title} />
              {openIndex === index ? (
                <img
                  src={ArrowUp}
                  alt="ArrowUp"
                  onClick={() => setOpenIndex(null)}
                />
              ) : (
                <PriceHeaderPlans>
                  <p>A partir de</p>
                  <p>
                    R$ <strong>{channel.annualPrice}</strong>/mês
                  </p>
                </PriceHeaderPlans>
              )}
            </div>
            <PlansDescription>{channel.contentText}</PlansDescription>
            <PlannContainer>
              <AnnualPlan
                checked={paymentType === "annual"}
                onClick={() => handleRadioChange(channel.id, "annual")}
              >
                <Discount checked={paymentType === "annual"}>
                  <p>{channel.discount}% de desconto</p>
                </Discount>
                <RadioContainer>
                  <HiddenRadio
                    type="radio"
                    value="annual"
                    checked={paymentType === "annual"}
                  />
                  <CustomRadio />
                  <PriceRadioLabel checked={paymentType === "annual"}>
                    ANUAL
                  </PriceRadioLabel>
                </RadioContainer>
                <AnnualPrice checked={paymentType === "annual"}>
                  <p>
                    12x R$ <strong>{channel.annualPrice}</strong>
                  </p>
                  <small>Total R$ {channel.totalPrice}/ano</small>
                </AnnualPrice>
                <CinemaOffer checked={paymentType === "annual"}>
                  <p>
                    <strong>Ganhe R$ 40</strong> <br /> na ingresso.com
                  </p>
                </CinemaOffer>
              </AnnualPlan>
              <MonthlyPlan
                checked={paymentType === "monthly"}
                onClick={() => handleRadioChange(channel.id, "monthly")}
              >
                <RadioContainer>
                  <HiddenRadio
                    type="radio"
                    value="monthly"
                    checked={paymentType === "monthly"}
                  />
                  <CustomRadio />
                  <PriceRadioLabel checked={paymentType === "monthly"}>
                    MENSAL
                  </PriceRadioLabel>
                </RadioContainer>
                <PriceMonthly checked={paymentType === "monthly"}>
                  R$ <strong>{channel.monthlyPrice}</strong>/mês
                </PriceMonthly>
              </MonthlyPlan>
              {openIndex === index ? (
                <CtaLink
                  onClick={() => setOpenIndex(index)}
                  isOpen={openIndex === index}
                  href={
                    paymentType === "annual"
                      ? channel.annualCtaUrl
                      : channel.monthlyCtaUrl
                  }
                >
                  Experimente
                </CtaLink>
              ) : (
                <a href={"#" + channel.id}>
                  <CtaButton
                    onClick={() => setOpenIndex(index)}
                    isOpen={openIndex === index}
                  >
                    Experimente
                  </CtaButton>
                </a>
              )}
            </PlannContainer>
          </Accordion>
        </AccordionContainer>
      ))}
    </Section>
  );
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 45px 8px 84px;
  background-color: #202020;
`;

const Title = styled.h4`
  font-size: 28px;
  color: white;
  text-align: center;
`;

const SubTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
`;

const BenefitsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  margin-top: 10px;
  max-width: 400px;
`;

const AccordionContainer = styled.div`
  scroll-margin-top: 30px;
`;

const Accordion = styled.div`
  position: relative;
  border: 2px solid ${({ isOpen }) => (isOpen ? "#ff8000" : "transparent")};
  width: 100%;
  background-color: #393939;
  padding: 8px;
  margin-top: 32px;
  border-radius: 6px;
  max-width: 400px;
  height: ${({ isOpen }) => (isOpen ? "auto" : "120px")};
  overflow: hidden;
  transition: height 0.3s ease;

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 28px;
    min-height: 52px;
    margin-bottom: ${({ isOpen }) => (isOpen ? "0" : "60px")};

    @media (max-width: 425px) {
      padding: 0 12px;
    }
  }

  img {
    max-height: 40px;
  }
`;

const PlansDescription = styled.p`
  color: #ffffff;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  padding: 0 24px;

  @media (max-width: 425px) {
    padding: 0 8px;
  }
`;

const PlannContainer = styled.div`
  background-color: #222222;
  width: 100%;
  padding: 18px 12px;
  margin-top: 22px;
  border-radius: 4px;
  padding-bottom: 72px;
`;

const AnnualPlan = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 125px;
  border-radius: 4px;
  border: 2px solid ${({ checked }) => (checked ? "#ff8000" : "transparent")};
  transition: border-color 0.3s ease;
  padding: 0 30px;

  @media (max-width: 425px) {
    padding: 0 8px;
  }
`;

const MonthlyPlan = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 62px;
  border: 2px solid ${({ checked }) => (checked ? "#ff8000" : "transparent")};
  border-radius: 4px;
  margin-top: 16px;
  transition: border-color 0.3s ease;
  padding: 0 30px;

  @media (max-width: 425px) {
    padding: 0 8px;
  }
`;

const CtaLink = styled.a`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: ${({ isOpen }) => (isOpen ? "20px" : "10px")};
  left: 50%;
  transform: translateX(-50%);
  background: rgb(255, 128, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(255, 206, 0, 1) 100%
  );
  width: ${({ isOpen }) => (isOpen ? "91%" : "97%")};
  height: ${({ isOpen }) => (isOpen ? "50px" : "40px")};
  font-size: 18px;
  border-radius: 4px;

  &:hover {
    color: #000000;
    opacity: 0.8;
  }
`;

const CtaButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: ${({ isOpen }) => (isOpen ? "20px" : "10px")};
  left: 50%;
  transform: translateX(-50%);
  background: rgb(255, 128, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(255, 206, 0, 1) 100%
  );
  width: ${({ isOpen }) => (isOpen ? "90%" : "97%")};
  height: ${({ isOpen }) => (isOpen ? "50px" : "40px")};
  font-size: 18px;
  border-radius: 4px;

  &:hover {
    color: #000000;
    opacity: 0.8;
  }
`;

const RadioContainer = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  margin: 0;

  /* p {
    font-size: 16px;
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
  } */
`;

const HiddenRadio = styled.input`
  display: none;

  &:checked + span {
    background-color: transparent;
    border: 2px solid #ff8000;
  }

  &:checked + span::before {
    transform: scale(1);
  }
`;

const CustomRadio = styled.span`
  position: relative;
  display: inline-block;
  width: 21px;
  height: 21px;
  border: 3px solid #727272;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #ff8000;
    transform: scale(0);
    transition: all 0.3s ease;
  }
`;

const PriceHeaderPlans = styled.div`
  p {
    font-size: 16px;
    color: #ffffff;

    strong {
      font-size: 24px;
    }
  }
`;

const PriceMonthly = styled.p`
  font-size: 16px;
  color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};

  strong {
    font-size: 24px;
  }
`;

const PriceRadioLabel = styled.p`
  font-size: 16px;
  color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
  font-weight: ${({ checked }) => (checked ? "bold" : "normal")};
  margin-left: 8px;
`;

const Discount = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 6px;
  left: 0;
  background-color: ${({ checked }) => (checked ? "#ff8000" : "#1D1D1D")};
  padding: 6px;
  border-radius: 0 99px 99px 0;
  min-width: 40%;

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 14px;
  }
`;

const CinemaOffer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  right: 0;
  bottom: 6px;
  background-color: ${({ checked }) => (checked ? "#6c04ba" : "#1D1D1D")};
  padding: 6px;
  border-radius: 99px 0 0 99px;
  /* width: 48%; */

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 16px;
    line-height: 18px;
  }
`;

const AnnualPrice = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 6px;
  background-color: transparent;
  /* width: 48%; */

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 16px;
  }

  strong {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 24px;
  }

  small {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 14px;
  }
`;
